import prefixNamespace from '@/utils/prefix-namespace'
import { storeKeyNameSpace } from '@/constants/stores'
export const _types = {
    getters: {
        GET_STORE_SPEED: 'getStoreSpeed',
    },
    actions: {
        START_TRIAL: 'startTrial',
        GET_STORE_SPEED: 'getStoreSpeed',
        GET_SPEED_SUMMARY_RESYNC: 'getSpeedSummaryResync',
        GET_CHECK_SYNC_SPEED_SUMMARY: 'getCheckSyncSpeedSummary'
    },
    mutations: {
        SET_STORE_SPEED: 'getStoreSpeed',
    }
}
export const types = prefixNamespace(`${storeKeyNameSpace.DASHBOARD}/`, _types)
export const quickBoxs = [{
    type: 'optimize',
    icon: 'icon-actual.svg',
    status: 'optimize',
    imageFound: '100',
    fileFound: 0,
    routerName: 'OPTIMIZE_IMAGE',
    isVisible: false,
    new: false
},
{
    type: 'swift_expert',
    icon: 'icon-expert.svg',
    status: 'new',
    routerName: 'SWIFT_EXPERT',
    isVisible: true,
    new: true
},
{
    type: 'preloading',
    icon: 'icon-preloading.svg',
    status: 'basic',
    routerName: 'PRELOADING',
    isVisible: false,
    new: false
},
{
    type: 'loading_screen',
    icon: 'icon-loading.svg',
    status: 'inactive',
    routerName: 'LOADING_SCREEN',
    isVisible: false,
    new: false
}]
export const tutorials = [{
    key: "preloading",
    image: "",
    title: "Set Up Preloading",
    description: "Predict customers’ next page and download its content in advance.",
    href: 'https://app.crisp.chat/website/cba1c5c9-861b-4b5a-a099-a4240567ecb3/helpdesk/articles/en/b5a2780a-aef8-4d8e-bd83-5c2f44b28dd4/',
    buttonName: "Translate now",
    routerName: "",
    disabled: true,
    youtubeEmbed: "https://www.youtube.com/embed/rHxi7NltPGs",
},
{
    key: "loading_screen",
    image: "",
    title: "Set Up Loading Screen",
    description: "We use eye-catching animations to enhance user experience while they wait for pages to load.",
    href: 'https://help.perfectapps.io/en/article/how-does-loading-screen-work-9kw3v1/',
    buttonName: "Edit now",
    routerName: "TRANSLATION_MANAGEMENT",
    disabled: false,
    youtubeEmbed: "https://www.youtube.com/embed/uVUIkhZTBKo",
}]
export const blogs = [
    {
        title: 'dashboard.blogs.blog_1',
        imageName: 'blog-one.svg',
        href: 'https://help.perfectapps.io/en/article/understanding-smart-preloading-and-how-top-companies-uses-it-to-speed-up-their-sites-mrcjgj/?1612173203914'
    },
    {
        title: 'dashboard.blogs.blog_2',
        imageName: 'blog-two.svg',
        href: 'https://go.onecommerce.io/Shopify-FireApps029'
    },
    {
        title: 'dashboard.blogs.blog_3',
        imageName: 'blog-three.svg',
        href: 'https://help.perfectapps.io/en/article/how-is-the-price-of-swift-expert-service-in-comparison-to-other-speed-services-price-1kpnmyh/'
    },
    {
        title: 'dashboard.blogs.blog_4',
        imageName: 'blog-three.svg',
        href: 'https://help.perfectapps.io/en/article/why-speed-score-on-google-pagespeed-insight-important-1jskoe5/'
    },
    {
        title: 'dashboard.blogs.blog_5',
        imageName: 'blog-three.svg',
        href: 'https://go.onecommerce.io/Shopify-FireApps030'
    },
    {
        title: 'dashboard.blogs.blog_6',
        imageName: 'blog-three.svg',
        href: 'https://go.onecommerce.io/Shopify-FireApps031'
    }
]
